import React, { useState } from "react";
import { Header } from "./Header";
import { Hero } from "./Hero";
import { Services } from "./Services";
import { About } from "./About";
import { Testimonials } from "./Testimonials";
import { Contact } from "./Contact";
import { LinkedInFollowButton } from "./LinkedInFollowButton";
import { Footer } from "./Footer";

export const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <Services />
      <About />
      <Testimonials />
      <Contact />
      <LinkedInFollowButton />
      <Footer />
    </div>
  );
};